import React from "react";
import { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import "./IpdAll.css";
import InvoiceModal from "../InvoiceModal";
import { toast } from "react-toastify";
import CustomDatePicker from "../../../resuableComponents/CustomDatePicker";
import CustomTimePicker from "../../../resuableComponents/CustomTimePicker";
import CustomDropdown from "../../../resuableComponents/CustomDropdown";
import dayjs from "dayjs";
import SkeletonLoader from "../../../resuableComponents/SkeletonLoader";
import ConfirmationModal from "../../../resuableComponents/ConfirmationModal";
import {
  FaTrashAlt,
  FaFileAlt,
  FaEdit,
  FaCheckCircle,
  FaTimes,
} from "react-icons/fa";
function IpdAll({ patientId, onUpdateSuccess }) {
  const [appointments, setAppointments] = useState([]);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [diagnosis, setDiagnosis] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showConsultationModal, setShowConsultationModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [modalMode, setModalMode] = useState("add"); // 'add' or 'view'

  // or however you toggle this
  const [admissionDate, setAdmissionDate] = useState(null);
  const [admissionTime, setAdmissionTime] = useState(null);
  const [roomNumber, setRoomNumber] = useState("");
  const [bedNumber, setBedNumber] = useState("");
  const [reason, setReason] = useState("");

  // Consultation form states
  const [bp, setBp] = useState("");
  const [bsl, setBsl] = useState("");
  const [weight, setWeight] = useState("");
  const [temperature, setTemperature] = useState("");
  const [pulse, setPulse] = useState("");
  const [complaints, setComplaints] = useState("");
  const [treatments, setTreatments] = useState([]);
  const [medicineName, setMedicineName] = useState("");
  const [followUpDate, setFollowUpDate] = useState(null);
  const [consultationLoading, setConsultationLoading] = useState(false);

  const authData = JSON.parse(localStorage.getItem("authData"));
  const doctorId = authData?.user?._id;
  const token = authData?.accessToken;
  const [treatmentOptions, setTreatmentOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  //declaration for meicines
  const [medicines, setMedicines] = useState([]);
  const [admissionInfo, setAdmissionInfo] = useState(null);
  const [admissionId, setAdmissionId] = useState("");
  const [errors, setErrors] = useState({});

  //IPD
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editRoomNumber, setEditRoomNumber] = useState("");
  const [editBedNumber, setEditBedNumber] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [editReason, setEditReason] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [dischargedDate, setDischargedDate] = useState(null);
  const [dischargedTime, setDischargedTime] = useState(null);
  const [showObservationModal, setShowObservationModal] = useState(false);
  const [notes, setNotes] = useState("");
  const [observations, setObservations] = useState("");
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [treatmentIdToDelete, setTreatmentIdToDelete] = useState(null);
  const [treatmentsData, setTreatmentsData] = useState([]);
  const [selectedTreatment, setSelectedTreatment] = useState(null);
  const [isTreatmentModalOpen, setIsTreatmentModalOpen] = useState(false);
  const [treatmentRefreshKey, setTreatmentRefreshKey] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const [currentTreatment, setCurrentTreatment] = useState(null);
  const [oxygen, setOxygen] = useState("");

  const openEditModal = () => {
    setMedicines(observations.medicines || []);
    //setShowEditModal(true);
    setEditRoomNumber(admissionInfo.roomNumber);
    setEditBedNumber(admissionInfo.bedNumber);
    setEditReason(admissionInfo.reason);
    setEditStatus(admissionInfo.status);
    // Initialize discharged date and time if they exist
    if (admissionInfo.dischargedDate) {
      setDischargedDate(dayjs(admissionInfo.dischargedDate, "DD-MM-YYYY"));
    } else {
      setDischargedDate(null);
    }
    if (admissionInfo.dischargedTime) {
      setDischargedTime(dayjs(admissionInfo.dischargedTime, "HH:mm"));
    } else {
      setDischargedTime(null);
    }
    setIsEditModalOpen(true);
  };
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (
        medicineDropdownRef.current &&
        !medicineDropdownRef.current.contains(event.target)
      ) {
        setShowMedicineDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // const treatmentOptions = [
  //   "Enema",
  //   "Vomiting",
  //   "Laxative",
  //   "Oil Massage",
  //   "Steam bath",
  // ];

  const fetchAppointments = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}get-all-admission?patientId=${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const allAdmissions = res.data.result || [];

      // Find the first admission with status "admitted"
      const admittedRecord = allAdmissions.find(
        (admission) => admission.status === "admitted"
      );

      if (admittedRecord) {
        setAdmissionId(admittedRecord._id);
        setAdmissionInfo(admittedRecord);
      } else {
        setAdmissionId("");
        setAdmissionInfo(null);
        setTreatmentsData([]);
      }

      setAppointments(allAdmissions);
    } catch (err) {
      console.error("Failed to fetch appointments:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!patientId) return;
    fetchAppointments();
  }, [patientId]);

  useEffect(() => {
    if (!admissionId) return;
    fetchAdmissionDetails(admissionId);
    fetchTreatments(admissionId);
  }, [admissionId, treatmentRefreshKey]);

  const [loadingAdmissionDetails, setLoadingAdmissionDetails] = useState(false);

  const fetchAdmissionDetails = async (admissionId) => {
    try {
      setLoadingAdmissionDetails(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}get-admission?admissionId=${admissionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const admission =
        res.data?.result ?? res.data?.admission ?? res.data ?? null;
      if (admission && typeof admission === "object") {
        setAdmissionInfo(admission);
      }
    } catch (err) {
      console.error("Failed to fetch admission details:", err);
    } finally {
      setLoadingAdmissionDetails(false);
    }
  };

  const handleUpdateAdmission = async () => {
    const errors = {};



    // Validate discharged date and time when status is "discharged"
    if (editStatus === "discharged") {
      if (!dischargedDate) {
        errors.dischargedDate = "Discharged date is required.";
      }
      if (!dischargedTime) {
        errors.dischargedTime = "Discharged time is required.";
      }
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return; // stop here if invalid
    }

    setFormErrors({}); // clear errors

    const admissionId = admissionInfo._id;
    const payload = {
      roomNumber: editRoomNumber,
      bedNumber: editBedNumber,
      reason: editReason,
      status: editStatus,
    };

    // Include discharged date and time in payload if status is "discharged"
    if (editStatus === "discharged" && dischargedDate && dischargedTime) {
      payload.dischargedDate = dayjs(dischargedDate).format("DD-MM-YYYY");
      payload.dischargedTime = dayjs(dischargedTime).format("HH:mm");
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}update-admission/${admissionId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Admission updated successfully.");
      setTreatmentRefreshKey((prev) => prev + 1);
      setAdmissionInfo(null);
      setIsEditModalOpen(false);
      fetchAdmissionDetails(admissionId);

      if (onUpdateSuccess) {
        onUpdateSuccess();
      }
    } catch (err) {
      console.error("Failed to update admission:", err);
      toast.error("Update failed.");
    }
  };

  const handleAddObservation = async () => {
    const errors = {};

    // Validate BP: must be in format "number/number" (e.g. 120/80)
    if (bp.trim() !== "") {
      const bpPattern = /^\d{2,3}\/\d{2,3}$/;
      if (!bpPattern.test(bp.trim())) {
        errors.bp = "BP must be in format 'systolic/diastolic', e.g. 120/80.";
      }
    }

    // Validate pulse: positive integer, reasonable range (30-200)
    if (pulse.trim() !== "") {
      const pulseNum = Number(pulse);
      if (!Number.isInteger(pulseNum) || pulseNum < 30 || pulseNum > 200) {
        errors.pulse = "Enter a valid pulse between 30 and 200.";
      }
    }

    // Validate temperature (°F): float between 90 and 110
    if (temperature.trim() !== "") {
      const tempNum = Number(temperature);
      if (isNaN(tempNum) || tempNum < 90 || tempNum > 110) {
        errors.temperature =
          "Enter a valid temperature between 90°F and 110°F.";
      }
    }

    // Validate oxygen (%): integer 70 to 100
    if (oxygen.trim() !== "") {
      const oxygenNum = Number(oxygen);
      if (!Number.isInteger(oxygenNum) || oxygenNum < 70 || oxygenNum > 100) {
        errors.oxygen = "Enter a valid oxygen saturation between 70% and 100%.";
      }
    }

    // Validate weight (kg): positive number, reasonable range (1-500)
    if (weight.trim() !== "") {
      const weightNum = Number(weight);
      if (isNaN(weightNum) || weightNum <= 0 || weightNum > 500) {
        errors.weight = "Enter a valid weight between 1kg and 500kg.";
      }
    }

    // Validate treatments: must be a non-empty array
    if (!treatments || !Array.isArray(treatments) || treatments.length === 0) {
      errors.treatments = "Please add at least one treatment before submitting.";
    }

    // Validate medicines: must be a non-empty array
    if (!medicines || !Array.isArray(medicines) || medicines.length === 0) {
      errors.medicines = "Please add at least one medicine before submitting.";
    }

    // Validate complaints: must not be empty
    if (!complaints || complaints.trim() === "") {
      errors.complaints = "Please enter patient complaints before submitting.";
    }

    // If errors, set state, show all errors in toast messages, and do not submit
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      // Show all errors in toast messages so user knows all issues at once
      const allErrors = Object.values(errors);
      // Show all errors sequentially with a small delay so user can see each one
      allErrors.forEach((errorMsg, index) => {
        setTimeout(() => {
          toast.error(errorMsg);
        }, index * 500); // Stagger toasts by 500ms so they're readable
      });
      return;
    }

    // Clear errors if valid
    setFormErrors({});

    // Proceed with API call
    try {
      // Convert foodCharges dates from "DD-MM-YYYY" to ISO date strings
      const formattedFoodCharges =
        foodCharges.length > 0
          ? foodCharges.map((food) => {
              let formattedDate = food.date;
              if (food.date) {
                // If date is in "DD-MM-YYYY" format, convert to ISO string
                if (
                  typeof food.date === "string" &&
                  /^\d{2}-\d{2}-\d{4}$/.test(food.date)
                ) {
                  formattedDate = dayjs(food.date, "DD-MM-YYYY").toISOString();
                } else if (food.date instanceof Date) {
                  // If it's already a Date object, convert to ISO string
                  formattedDate = food.date.toISOString();
                }
                // If it's already an ISO string or other format, keep it as is
              }
              return {
                ...food,
                date: formattedDate,
              };
            })
          : undefined;

      const payload = {
        admissionId,
        notes,
        observations: {
          bp,
          pulse,
          temperature,
          oxygen,
          weight,
        },
        complaints,
        medicines,
        treatments,
        foodCharges: formattedFoodCharges,
      };

      await axios.post(
        `${process.env.REACT_APP_API_URL}add-treatment`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Observation added successfully.");
      resetObservationForm();
      setShowObservationModal(false);
      setTreatmentRefreshKey((prev) => prev + 1);
    } catch (error) {
      console.error("Failed to add observation:", error);
      
      // Map API errors to user-friendly messages
      const apiError = error.response?.data?.error || error.response?.data?.message || "";
      let userFriendlyMessage = "Failed to add observation. Please try again.";
      
      if (apiError) {
        const errorLower = apiError.toLowerCase();
        
        // Map common API errors to user-friendly messages
        if (errorLower.includes("treatments must be a non-empty array") || 
            errorLower.includes("treatments") && errorLower.includes("empty")) {
          userFriendlyMessage = "Please add at least one treatment before submitting.";
        } else if (errorLower.includes("medicines must be a non-empty array") || 
                   errorLower.includes("medicines") && errorLower.includes("empty")) {
          userFriendlyMessage = "Please add at least one medicine before submitting.";
        } else if (errorLower.includes("complaints") && errorLower.includes("required")) {
          userFriendlyMessage = "Please enter patient complaints before submitting.";
        } else if (errorLower.includes("admission") && errorLower.includes("not found")) {
          userFriendlyMessage = "Admission information not found. Please refresh the page.";
        } else if (errorLower.includes("unauthorized") || errorLower.includes("token")) {
          userFriendlyMessage = "Your session has expired. Please log in again.";
        } else if (errorLower.includes("network") || errorLower.includes("timeout")) {
          userFriendlyMessage = "Network error. Please check your connection and try again.";
        } else {
          // If it's a user-friendly message already, use it; otherwise use generic
          userFriendlyMessage = apiError.length > 0 && apiError.length < 100 
            ? apiError 
            : userFriendlyMessage;
        }
      } else if (error.message) {
        // Handle network errors
        if (error.message.includes("Network Error") || error.message.includes("timeout")) {
          userFriendlyMessage = "Network error. Please check your connection and try again.";
        }
      }
      
      toast.error(userFriendlyMessage);
    }
  };

  const fetchTreatments = async (admissionId) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}get-all-treatment?admissionId=${admissionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTreatmentsData(res.data.result || []);
      console.log("Fetched treatments:", res.data.result);
    } catch (err) {
      console.error("Error fetching treatments:", err);
      // If 404, set empty array to show "No observations found"
      if (err.response?.status === 404) {
        setTreatmentsData([]);
      } else {
        // For other errors, you might want to keep existing data or show error
        // For now, set empty array to clear stale data
        setTreatmentsData([]);
      }
    }
  };

  const handleEditObservation = (treatment) => {
    try {
      setCurrentTreatment(treatment);
      setNotes(treatment.notes || "");
      setComplaints(treatment.complaints || "");
      setMedicines(treatment.medicines || []);
      setTreatments(treatment.treatments || []);
      setFoodCharges(treatment.foodCharges || []);

      // Initialize observation fields
      setBp(treatment.observations?.bp || "");
      setPulse(treatment.observations?.pulse || "");
      setTemperature(treatment.observations?.temperature || "");
      setOxygen(treatment.observations?.oxygen || "");
      setWeight(treatment.observations?.weight || "");

      setShowEditModal(true);
    } catch (error) {
      console.error("Error editing observation:", error);
      toast.error("Failed to edit observation.");
    }
  };

  const handleSaveEdit = async () => {
    const newErrors = {};

    // Validate BP: must be in format "number/number" (e.g. 120/80) if provided
    if (bp.trim() !== "") {
      const bpPattern = /^\d{2,3}\/\d{2,3}$/;
      if (!bpPattern.test(bp.trim())) {
        newErrors.bp = "BP must be in format 'systolic/diastolic', e.g. 120/80.";
      }
    }

    // Validate pulse: positive integer, reasonable range (30-200) if provided
    if (pulse.trim() !== "") {
      const pulseNum = Number(pulse);
      if (!Number.isInteger(pulseNum) || pulseNum < 30 || pulseNum > 200) {
        newErrors.pulse = "Enter a valid pulse between 30 and 200.";
      }
    }

    // Validate temperature (°F): float between 90 and 110 if provided
    if (temperature.trim() !== "") {
      const tempNum = Number(temperature);
      if (isNaN(tempNum) || tempNum < 90 || tempNum > 110) {
        newErrors.temperature = "Enter a valid temperature between 90°F and 110°F.";
      }
    }

    // Validate oxygen (%): integer 70 to 100 if provided
    if (oxygen.trim() !== "") {
      const oxygenNum = Number(oxygen);
      if (!Number.isInteger(oxygenNum) || oxygenNum < 70 || oxygenNum > 100) {
        newErrors.oxygen = "Enter a valid oxygen saturation between 70% and 100%.";
      }
    }

    // Validate weight (kg): positive number, reasonable range (1-500) if provided
    if (weight.trim() !== "") {
      const weightNum = Number(weight);
      if (isNaN(weightNum) || weightNum <= 0 || weightNum > 500) {
        newErrors.weight = "Enter a valid weight between 1kg and 500kg.";
      }
    }
    if (!complaints.trim()) {
      newErrors.complaints = "Please enter patient complaints before submitting.";
    }
    if (!treatments || !Array.isArray(treatments) || treatments.length === 0) {
      newErrors.treatments = "Please add at least one treatment before submitting.";
    }
    if (!medicines || !Array.isArray(medicines) || medicines.length === 0) {
      newErrors.medicines = "Please add at least one medicine before submitting.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      // Show all errors in toast messages so user knows all issues at once
      const allErrors = Object.values(newErrors);
      allErrors.forEach((errorMsg, index) => {
        setTimeout(() => {
          toast.error(errorMsg);
        }, index * 500); // Stagger toasts by 500ms so they're readable
      });
      return;
    }

    setErrors({}); // Clear errors if all valid

    try {
      const formattedMedicines = medicines.map((medicine) => ({
        medicineId: medicine.medicineId || medicine._id,
        _id: medicine._id,
        name: medicine.name,
        dosage: medicine.dosage,
        cost: medicine.cost,
      }));

      const formattedTreatments = treatments.map((treatment) => ({
        _id: treatment._id,
        name: treatment.name,
        cost: treatment.cost,
      }));

      // Convert foodCharges dates from "DD-MM-YYYY" to ISO date strings
      const formattedFoodCharges =
        foodCharges.length > 0
          ? foodCharges.map((food) => {
              let formattedDate = food.date;
              if (food.date) {
                // If date is in "DD-MM-YYYY" format, convert to ISO string
                if (
                  typeof food.date === "string" &&
                  /^\d{2}-\d{2}-\d{4}$/.test(food.date)
                ) {
                  formattedDate = dayjs(food.date, "DD-MM-YYYY").toISOString();
                } else if (food.date instanceof Date) {
                  // If it's already a Date object, convert to ISO string
                  formattedDate = food.date.toISOString();
                }
                // If it's already an ISO string or other format, keep it as is
              }
              return {
                ...food,
                date: formattedDate,
              };
            })
          : undefined;

      const updatedTreatment = {
        observations: { bp, pulse, temperature, oxygen, weight },
        notes,
        complaints,
        medicines: formattedMedicines,
        treatments: formattedTreatments,
        foodCharges: formattedFoodCharges,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}edit-treatment/${currentTreatment._id}`,
        updatedTreatment,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setTreatmentRefreshKey((prev) => prev + 1);
      resetEditModal();
      setShowEditModal(false);
      fetchTreatments(admissionId);
      toast.success("Treatment updated successfully.");
    } catch (error) {
      console.error("Failed to save treatment:", error);
      
      // Map API errors to user-friendly messages
      const apiError = error.response?.data?.error || error.response?.data?.message || "";
      let userFriendlyMessage = "Failed to update observation. Please try again.";
      
      if (apiError) {
        const errorLower = apiError.toLowerCase();
        
        // Map common API errors to user-friendly messages
        if (errorLower.includes("treatments must be a non-empty array") || 
            errorLower.includes("treatments") && errorLower.includes("empty")) {
          userFriendlyMessage = "Please add at least one treatment before submitting.";
        } else if (errorLower.includes("medicines must be a non-empty array") || 
                   errorLower.includes("medicines") && errorLower.includes("empty")) {
          userFriendlyMessage = "Please add at least one medicine before submitting.";
        } else if (errorLower.includes("complaints") && errorLower.includes("required")) {
          userFriendlyMessage = "Please enter patient complaints before submitting.";
        } else if (errorLower.includes("treatment not found") || errorLower.includes("not found")) {
          userFriendlyMessage = "Observation not found. Please refresh the page.";
        } else if (errorLower.includes("unauthorized") || errorLower.includes("token")) {
          userFriendlyMessage = "Your session has expired. Please log in again.";
        } else if (errorLower.includes("network") || errorLower.includes("timeout")) {
          userFriendlyMessage = "Network error. Please check your connection and try again.";
        } else {
          // If it's a user-friendly message already, use it; otherwise use generic
          userFriendlyMessage = apiError.length > 0 && apiError.length < 100 
            ? apiError 
            : userFriendlyMessage;
        }
      } else if (error.message) {
        // Handle network errors
        if (error.message.includes("Network Error") || error.message.includes("timeout")) {
          userFriendlyMessage = "Network error. Please check your connection and try again.";
        }
      }
      
      toast.error(userFriendlyMessage);
    }
  };

  const formatDate = (isoDate) => {
    const d = new Date(isoDate);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format ISO date string to DD-MM-YYYY format
  const formatFoodChargeDate = (dateString) => {
    if (!dateString) return "";
    // Check if it's already in DD-MM-YYYY format
    if (
      typeof dateString === "string" &&
      /^\d{2}-\d{2}-\d{4}$/.test(dateString)
    ) {
      return dateString;
    }
    // If it's an ISO string, convert it
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // Return original if invalid
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString; // Return original if conversion fails
    }
  };

  // Extract and format time from ISO date string or use provided time
  const formatFoodChargeTime = (dateString, timeString) => {
    // If time is provided separately and is not empty, use it
    if (timeString && timeString.trim() !== "") {
      return timeString;
    }
    // Otherwise, extract time from ISO date string
    if (dateString) {
      try {
        // Check if it's already in DD-MM-YYYY format (no time info)
        if (
          typeof dateString === "string" &&
          /^\d{2}-\d{2}-\d{4}$/.test(dateString)
        ) {
          return "";
        }
        // Try to extract time directly from ISO string format: "2025-11-25T18:30:00.000Z"
        if (typeof dateString === "string" && dateString.includes("T")) {
          const timeMatch = dateString.match(/T(\d{2}):(\d{2})/);
          if (timeMatch) {
            return `${timeMatch[1]}:${timeMatch[2]}`;
          }
        }
        // Fallback: Parse ISO string using dayjs (handles UTC and timezone correctly)
        const date = dayjs(dateString);
        if (date.isValid()) {
          // Format as HH:mm in local time
          return date.format("HH:mm");
        }
      } catch (error) {
        console.error("Error formatting food charge time:", error);
      }
    }
    return "";
  };

  const handleSaveAdmission = async () => {
    const errors = {};
    if (!admissionDate) errors.admissionDate = "Admission date is required.";
    if (!admissionTime) errors.admissionTime = "Admission time is required.";
    
    if (!reason) errors.reason = "Reason is required.";

    const roomNumberValue = String(roomNumber ?? "").trim();
    const bedNumberValue = String(bedNumber ?? "").trim();

    if (roomNumberValue) {
      const roomNum = Number(roomNumberValue);
      if (Number.isNaN(roomNum)) errors.roomNumber = "Room number must be a number.";
    }

    if (bedNumberValue) {
      const bedNum = Number(bedNumberValue);
      if (Number.isNaN(bedNum)) errors.bedNumber = "Bed number must be a number.";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      toast.error("Please fix the highlighted errors.");
      return;
    }

    setFormErrors({});

    const formattedDate = dayjs(admissionDate).format("DD-MM-YYYY");
    const formattedTime = dayjs(admissionTime).format("HH:mm");
    console.log("bed number is ", bedNumber);

    // API expects the (misspelled) key `addmissionTime`; send both for safety.
    const payload = {
      patientId,
      admissionDate: formattedDate,
      admissionTime: formattedTime,
      addmissionTime: formattedTime,
      reason,
    };

    if (roomNumberValue) payload.roomNumber = Number(roomNumberValue);
    if (bedNumberValue) payload.bedNumber = Number(bedNumberValue);

    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}admit-patient`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const newAdmission = res.data.admission;
      const newAdmissionId = newAdmission._id;
      setAdmissionId(newAdmissionId);
      setAdmissionInfo(newAdmission);
      setShowSuccessPopup(true);
      setAdmissionDate(null);
      setAdmissionTime(null);
      setRoomNumber("");
      setBedNumber("");
      setReason("");
      setShowForm(false);
      setTimeout(() => setShowSuccessPopup(false), 3000);
      toast.success("Case  added successfully.");
    } catch (err) {
      console.error("Failed to admit patient:", err);
      toast.error("Failed to admit patient.");
    } finally {
      setLoading(false);
    }
  };

  const resetConsultationForm = () => {
    setBp("");
    setBsl("");
    setWeight("");
    setTemperature("");
    setPulse("");
    setComplaints("");
    setDiagnosis("");
    setTreatments([]);
    setMedicines([]);
    setMedicineName("");
    setMedicineId("");
    setMedicineDosage("");
    setMedicineSearchTerm("");
    setShowMedicineDropdown(false);
    setFollowUpDate(null);
  };

  const handleTreatmentToggle = (treatment) => {
    const exists = treatments.some((t) => t._id === treatment._id);
    if (exists) {
      setTreatments(treatments.filter((t) => t._id !== treatment._id));
    } else {
      setTreatments([...treatments, treatment]);
    }
  };

  const addMedicine = () => {
    if (!medicineId || !medicineDosage) return;

    const selected = availableMedicines.find((m) => m._id === medicineId);
    if (!selected) return;

    setMedicines((prev) => [
      ...prev,
      {
        medicineId: selected._id,
        _id: selected._id,
        name: selected.name,
        dosage: medicineDosage.toString(),
        cost: selected.cost,
      },
    ]);

    setMedicineId("");
    setMedicineDosage("");
    setMedicineSearchTerm("");
    setShowMedicineDropdown(false);
  };

  // Food charges functions
  const addFoodCharge = () => {
    if (
      !foodItemName.trim() ||
      !foodQuantity ||
      !foodPrice ||
      !foodDate ||
      !foodTime
    ) {
      toast.error("Please fill all food charge fields.");
      return;
    }

    const quantity = Number(foodQuantity);
    const price = Number(foodPrice);

    if (isNaN(quantity) || quantity <= 0) {
      toast.error("Please enter a valid quantity.");
      return;
    }

    if (isNaN(price) || price <= 0) {
      toast.error("Please enter a valid price.");
      return;
    }

    const totalCost = quantity * price;
    const formattedDate = dayjs(foodDate).format("DD-MM-YYYY");
    const formattedTime = dayjs(foodTime).format("HH:mm");

    const newFoodCharge = {
      itemName: foodItemName.trim(),
      quantity: quantity,
      price: price,
      totalCost: totalCost,
      date: formattedDate,
      time: formattedTime,
    };

    setFoodCharges((prev) => [...prev, newFoodCharge]);

    // Reset form fields
    setFoodItemName("");
    setFoodQuantity("");
    setFoodPrice("");
    setFoodDate(null);
    setFoodTime(null);
  };

  const removeFoodCharge = (index) => {
    setFoodCharges((prev) => prev.filter((_, i) => i !== index));
  };

  const resetObservationForm = () => {
    setNotes("");
    setBp("");
    setPulse("");
    setTemperature("");
    setOxygen("");
    setWeight("");
    setComplaints("");
    setTreatments([]);
    setMedicines([]);
    setFoodCharges([]);
    setFoodItemName("");
    setFoodQuantity("");
    setFoodPrice("");
    setFoodDate(null);
    setFoodTime(null);
    setFormErrors({});
    setMedicineId("");
    setMedicineDosage("");
    setMedicineSearchTerm("");
    setShowMedicineDropdown(false);
  };

  const handleCloseObservationModal = () => {
    resetObservationForm();
    setShowObservationModal(false);
  };

  const resetEditModal = () => {
    setNotes("");
    setBp("");
    setPulse("");
    setTemperature("");
    setOxygen("");
    setWeight("");
    setComplaints("");
    setTreatments([]);
    setMedicines([]);
    setFoodCharges([]);
    setFoodItemName("");
    setFoodQuantity("");
    setFoodPrice("");
    setFoodDate(null);
    setFoodTime(null);
    setErrors({});
    setMedicineId("");
    setMedicineDosage("");
    setMedicineSearchTerm("");
    setShowMedicineDropdown(false);
    setCurrentTreatment(null);
  };

  const handleCloseEditModal = () => {
    resetEditModal();
    setShowEditModal(false);
  };

  const handleSaveConsultation = async () => {
    if (!complaints) {
      toast.error("Complaints are required");
      return;
    }

    const formatFollowUpDate = (dateValue) => {
      if (!dateValue) return "";
      return dayjs(dateValue).format("DD-MM-YYYY");
    };

    const consultationData = {
      appointmentId: selectedAppointment._id,
      observations: { bp, bsl, weight, temperature, pulse },
      complaints,
      diagnosis,
      treatments: treatments.map((t) => t.name),
      prescribedMedicines: medicines.map((m) => ({
        name: m.name,
        dosage: m.dosage,
      })),
      followUpDate: formatFollowUpDate(followUpDate),
    };

    try {
      setConsultationLoading(true);
      await axios.post(
        `${process.env.REACT_APP_API_URL}add-consultation`,
        consultationData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      resetConsultationForm();
      setShowConsultationModal(false);
      toast.success("Consultation added successfully!");
    } catch (error) {
      console.error("Error saving consultation:", error);
      toast.error(
        error.response?.data?.message || "Failed to save consultation"
      );
    } finally {
      setConsultationLoading(false);
    }
  };

  //New treatments by API
  useEffect(() => {
    const fetchTreatments = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}get-all-services`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setTreatmentOptions(response.data.result);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching treatments:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTreatments();
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  //Medicine part
  const [availableMedicines, setAvailableMedicines] = useState([]);
  const [medicineId, setMedicineId] = useState("");
  const [medicineDosage, setMedicineDosage] = useState("");
  const [medicineSearchTerm, setMedicineSearchTerm] = useState("");
  const [showMedicineDropdown, setShowMedicineDropdown] = useState(false);
  const medicineDropdownRef = useRef(null);

  // Filtered medicines based on search term
  const filteredMedicines = useMemo(() => {
    if (!medicineSearchTerm) return availableMedicines;
    return availableMedicines.filter((med) =>
      med.name.toLowerCase().includes(medicineSearchTerm.toLowerCase())
    );
  }, [medicineSearchTerm, availableMedicines]);

  // Food charges states
  const [foodCharges, setFoodCharges] = useState([]);
  const [foodItemName, setFoodItemName] = useState("");
  const [foodQuantity, setFoodQuantity] = useState("");
  const [foodPrice, setFoodPrice] = useState("");
  const [foodDate, setFoodDate] = useState(null);
  const [foodTime, setFoodTime] = useState(null);

  const [selectedMedicineIds, setSelectedMedicineIds] = useState([]);
  const [selectedTreatmentIds, setSelectedTreatmentIds] = useState([]);

  useEffect(() => {
    const fetchMedicines = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}get-all-medicines`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAvailableMedicines(res.data.result || []);
      } catch (error) {
        console.error("Failed to fetch medicines:", error);
      }
    };

    fetchMedicines();
  }, []);

  // ✅ Early returns must come after all hooks
  // Note: isLoading is only for treatments, don't block the whole page
  if (error) {
    console.error("Error loading treatments:", error);
  }

  const handleUpdateConsultation = async () => {
    if (!complaints) {
      toast.error("Complaints are required");
      return;
    }

    const formatFollowUpDate = (dateValue) => {
      if (!dateValue) return "";
      return dayjs(dateValue).format("DD-MM-YYYY");
    };

    const consultationData = {
      appointmentId: selectedAppointment._id,
      observations: { bp, bsl, weight, temperature, pulse },
      complaints,
      diagnosis,
      treatments: treatments.map((t) => t.name),
      prescribedMedicines: medicines.map((m) => ({
        name: m.name,
        dosage: m.dosage,
      })),
      followUpDate: formatFollowUpDate(followUpDate),
    };

    try {
      setConsultationLoading(true);
      await axios.post(
        `${process.env.REACT_APP_API_URL}edit-consultation`,
        consultationData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      resetConsultationForm();
      setShowConsultationModal(false);
      toast.success("Consultation updated successfully!");
    } catch (error) {
      console.error("Error updating consultation:", error);
      toast.error(
        error.response?.data?.message || "Failed to update consultation"
      );
    } finally {
      setConsultationLoading(false);
    }
  };

  const calculateMedicineCost = (medicine) => {
    // Assuming dosage is a number (like "2" for 2 tablets)
    // and cost is the price per unit
    const dosage = parseFloat(medicine.dosage) || 0;
    const cost = parseFloat(medicine.cost) || 0;
    return dosage * cost;
  };

  const calculateTotalMedicineCost = () => {
    return medicines.reduce((total, medicine) => {
      return total + calculateMedicineCost(medicine);
    }, 0);
  };

  const removeTreatment = (treatmentId) => {
    setTreatments((prevTreatments) =>
      prevTreatments.filter((treatment) => treatment._id !== treatmentId)
    );
  };

  const removeMedicine = (index) => {
    setMedicines((prevMedicines) =>
      prevMedicines.filter((_, i) => i !== index)
    );
  };

  //Delete treatment
  const handleDeleteObservation = (treatmentId) => {
    setTreatmentIdToDelete(treatmentId);
    setShowDeleteConfirmModal(true);
  };

  const confirmDeleteObservation = async () => {
    if (!treatmentIdToDelete) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}delete-treatment/${treatmentIdToDelete}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Observation deleted successfully");
      // Refresh the treatments list by incrementing the refresh key
      setTreatmentRefreshKey((prev) => prev + 1);
      // Also directly fetch treatments to ensure immediate update
      if (admissionId) {
        fetchTreatments(admissionId);
      }
      setShowDeleteConfirmModal(false);
      setTreatmentIdToDelete(null);
    } catch (error) {
      console.error("Failed to delete observation:", error);
      toast.error(
        `Failed to delete observation: ${
          error.response?.data?.message || error.message
        }`
      );
      setShowDeleteConfirmModal(false);
      setTreatmentIdToDelete(null);
    }
  };

  // Show skeleton loader during initial page load or when loading admission details
  if (loading || (admissionId && loadingAdmissionDetails && !admissionInfo)) {
    return (
      <div className="ipd-page-container">
        <div className="ipd-header">
          <div
            className="skeleton-line"
            style={{ width: "250px", height: "32px", marginBottom: "1.5rem" }}
          ></div>
        </div>
        <SkeletonLoader variant="admission-card" />
        <div style={{ marginTop: "2rem" }}>
          <SkeletonLoader variant="table" count={3} />
        </div>
      </div>
    );
  }

  return (
    <div className="ipd-page-container">
      <div className="ipd-header">
        <h2 className="ipd-title">Register IPD Case</h2>
        {!admissionId && (
          <button
            className={`ipd-button ${
              showForm ? "ipd-button-cancel" : "ipd-button-add"
            }`}
            onClick={() => setShowForm(!showForm)}
          >
            {showForm ? "Cancel" : "Add IPD Case"}
          </button>
        )}
      </div>

      {admissionInfo && (
        <div className="admission-card">
          <div className="admission-header">
            <h3 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FaFileAlt /> Admission Details
            </h3>
            <button
              onClick={openEditModal}
              className="ipd-button ipd-button-primary"
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              <FaEdit /> Edit Admission
            </button>
          </div>

          <div className="admission-grid">
            <div>
              <strong>Name:</strong> {admissionInfo.patient.name}
            </div>
            <div>
              <strong>Gender:</strong> {admissionInfo.patient.gender}
            </div>
            <div>
              <strong>Age:</strong> {admissionInfo.patient.age}
            </div>
            <div>
              <strong>Contact:</strong> {admissionInfo.patient.contact}
            </div>
            <div>
              <strong>Room No.:</strong> {admissionInfo.roomNumber}
            </div>
            <div>
              <strong>Bed No.:</strong> {admissionInfo.bedNumber}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <strong>Status:</strong>{" "}
              <FaCheckCircle style={{ color: "#198754" }} />{" "}
              {admissionInfo.status}
            </div>
            <div>
              <strong>Admission Date:</strong>{" "}
              {dayjs(admissionInfo.admissionDate).format("DD/MM/YYYY")}
            </div>
            <div className="full-row">
              <strong>Reason:</strong> {admissionInfo.reason}
            </div>
          </div>

          {isEditModalOpen && (
            <div className="ipd-modal-overlay">
              <div className="ipd-modal">
                <div className="ipd-modal-header">
                  <h3>Edit Admission</h3>
                  <button
                    className="ipd-modal-close"
                    onClick={() => setIsEditModalOpen(false)}
                  >
                    <FaTimes />
                  </button>
                </div>

                <div className="ipd-modal-body">
                  <div className="ipd-input-group">
                    <label className="ipd-label">Room Number</label>
                    <input
                      type="number"
                      min="1"
                      className="ipd-input"
                      value={editRoomNumber}
                      onChange={(e) => setEditRoomNumber(e.target.value)}
                    />
                    {formErrors.roomNumber && (
                      <p className="ipd-error-text">{formErrors.roomNumber}</p>
                    )}
                  </div>

                  <div className="ipd-input-group">
                    <label className="ipd-label">Bed Number</label>
                    <input
                      type="number"
                      min="1"
                      className="ipd-input"
                      value={editBedNumber}
                      onChange={(e) => setEditBedNumber(e.target.value)}
                    />
                    {formErrors.bedNumber && (
                      <p className="ipd-error-text">{formErrors.bedNumber}</p>
                    )}
                  </div>

                  <div className="ipd-input-group">
                    <label className="ipd-label">Reason</label>
                    <textarea
                      className="ipd-textarea"
                      rows={3}
                      value={editReason}
                      onChange={(e) => setEditReason(e.target.value)}
                    />
                  </div>

                  <div className="ipd-input-group">
                    <label className="ipd-label">Status</label>
                    <CustomDropdown
                      label="Select Status"
                      value={editStatus}
                      onChange={(value) => {
                        setEditStatus(value);
                        // Clear discharged date/time when changing from discharged to admitted
                        if (value === "admitted") {
                          setDischargedDate(null);
                          setDischargedTime(null);
                        }
                      }}
                      options={[
                        { value: "admitted", label: "Admitted" },
                        { value: "discharged", label: "Discharged" },
                      ]}
                    />
                  </div>

                  {editStatus === "discharged" && (
                    <>
                      <div className="ipd-form-row">
                        <div className="ipd-input-group">
                          <label className="ipd-label">Discharged Date</label>
                          <CustomDatePicker
                            label="Select Discharged Date"
                            value={dischargedDate}
                            onChange={setDischargedDate}
                          />
                          {formErrors.dischargedDate && (
                            <p className="ipd-error-text">
                              {formErrors.dischargedDate}
                            </p>
                          )}
                        </div>
                        <div className="ipd-input-group">
                          <label className="ipd-label">Discharged Time</label>
                          <CustomTimePicker
                            label="Select Discharged Time"
                            value={dischargedTime}
                            onChange={setDischargedTime}
                          />
                          {formErrors.dischargedTime && (
                            <p className="ipd-error-text">
                              {formErrors.dischargedTime}
                            </p>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="ipd-modal-footer">
                  <button
                    onClick={handleUpdateAdmission}
                    className="ipd-button ipd-button-primary"
                  >
                    Save
                  </button>
                  <button
                    onClick={() => setIsEditModalOpen(false)}
                    className="ipd-button"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {showForm && (
        <div className="ipd-form-wrapper">
          <div className="ipd-form">
            <div className="ipd-form-row">
              <div className="ipd-input-group">
                <label className="ipd-label">Admission Date</label>
                <CustomDatePicker
                  label="Select Admission Date"
                  value={admissionDate}
                  onChange={setAdmissionDate}
                />
              </div>
              <div className="ipd-input-group">
                <label className="ipd-label">Admission Time</label>
                <CustomTimePicker
                  label="Select Admission Time"
                  value={admissionTime}
                  onChange={setAdmissionTime}
                />
              </div>
            </div>

            <div className="ipd-input-group">
              <label className="ipd-label">Room Number</label>
              <input
                type="number"
                min="1"
                step="1"
                className="ipd-input"
                value={roomNumber}
                onChange={(e) => setRoomNumber(e.target.value)}
                placeholder="Enter Room number"
              />
              {formErrors.roomNumber && (
                <p className="ipd-error-text">{formErrors.roomNumber}</p>
              )}
            </div>

            <div className="ipd-input-group">
              <label className="ipd-label">Bed Number</label>
              <input
                type="number"
                min="1"
                step="1"
                className="ipd-input"
                value={bedNumber}
                placeholder="Enter Bed number"
                // Change the onChange handler to convert to number
                onChange={(e) => setBedNumber(e.target.value)}
              />
              {formErrors.bedNumber && (
                <p className="ipd-error-text">{formErrors.bedNumber}</p>
              )}
            </div>

            <div className="ipd-input-group">
              <label className="ipd-label">Reason</label>
              <textarea
                className="ipd-textarea"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter reason for admission"
              />
            </div>

            <div className="ipd-button-group">
              <button
                className="ipd-button ipd-button-primary"
                onClick={handleSaveAdmission}
              >
                Save Admission
              </button>
            </div>
          </div>
        </div>
      )}

      {admissionId && (
        <button
          className="ipd-button ipd-button-primary"
          onClick={() => setShowObservationModal(true)}
        >
          Add Observation
        </button>
      )}

      {/* Observation Modal */}
      {showObservationModal && (
        <div className="ipd-modal-overlay">
          <div className="ipd-modal">
            <div className="ipd-modal-header">
              <h3>Add Observation</h3>
              <button
                className="ipd-modal-close"
                onClick={handleCloseObservationModal}
              >
                <FaTimes />
              </button>
            </div>

            <div className="ipd-modal-body">
              <div className="ipd-input-group">
                <label className="ipd-label">Notes</label>
                <textarea
                  className="ipd-textarea"
                  placeholder="Enter notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">BP</label>
                <input
                  className="ipd-input"
                  placeholder="e.g. 120/80"
                  value={bp}
                  onChange={(e) => setBp(e.target.value)}
                />
                {formErrors.bp && (
                  <p className="ipd-error-text">{formErrors.bp}</p>
                )}
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Pulse</label>
                <input
                  className="ipd-input"
                  placeholder="e.g. 72"
                  value={pulse}
                  onChange={(e) => setPulse(e.target.value)}
                />
                {formErrors.pulse && (
                  <p className="ipd-error-text">{formErrors.pulse}</p>
                )}
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Temperature (°F)</label>
                <input
                  className="ipd-input"
                  placeholder="e.g. 98.6"
                  value={temperature}
                  onChange={(e) => setTemperature(e.target.value)}
                />
                {formErrors.temperature && (
                  <p className="ipd-error-text">{formErrors.temperature}</p>
                )}
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Oxygen (%)</label>
                <input
                  className="ipd-input"
                  placeholder="e.g. 98"
                  value={oxygen}
                  onChange={(e) => setOxygen(e.target.value)}
                />
                {formErrors.oxygen && (
                  <p className="ipd-error-text">{formErrors.oxygen}</p>
                )}
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Weight (kg)</label>
                <input
                  className="ipd-input"
                  placeholder="e.g. 65"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                />
                {formErrors.weight && (
                  <p className="ipd-error-text">{formErrors.weight}</p>
                )}
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Complaints</label>
                <textarea
                  className="ipd-textarea"
                  placeholder="Enter complaints"
                  value={complaints}
                  onChange={(e) => setComplaints(e.target.value)}
                />
              </div>

              <div className="ipd-section" ref={dropdownRef}>
                <h3 className="ipd-section-title">Treatments</h3>
                <div className="ipd-dropdown-wrapper">
                  <button
                    className="ipd-dropdown-toggle"
                    style={{ height: "56px" }}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <span>Select Treatments</span>
                    <span className="ipd-dropdown-icon">▾</span>
                  </button>

                  {isDropdownOpen && (
                    <div className="ipd-dropdown-menu">
                      {treatmentOptions.map((opt) => (
                        <div key={opt._id} className="ipd-checkbox-wrapper">
                          <label className="ipd-checkbox">
                            <input
                              type="checkbox"
                              checked={treatments.some(
                                (t) => t.name === opt.name
                              )}
                              onChange={() => handleTreatmentToggle(opt)}
                            />
                            <span className="ipd-checkbox-custom"></span>
                            <span className="ipd-checkbox-label">
                              {opt.name} (₹{opt.cost})
                            </span>
                          </label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {treatments.length > 0 && (
                  <div
                    className="ipd-medicines-list-container"
                    style={{ marginTop: "0.5rem" }}
                  >
                    <h4 className="ipd-list-title">Selected Treatments</h4>
                    <ul className="ipd-medicines-list">
                      {treatments.map((treatment, index) => (
                        <li
                          key={treatment._id || index}
                          className="ipd-medicine-item"
                        >
                          <div
                            style={{
                              flex: 1,
                              display: "flex",
                              gap: "5px",
                              alignItems: "center",
                            }}
                          >
                            <span className="ipd-medicine-name">
                              {treatment.name}
                            </span>
                            {treatment.cost && (
                              <span className="ipd-medicine-details">
                                (₹{treatment.cost})
                              </span>
                            )}
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleTreatmentToggle(treatment);
                            }}
                            className="ipd-remove-button"
                            title="Remove treatment"
                          >
                            <FaTrashAlt />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              <div className="ipd-section">
                <h3 className="ipd-section-title">Medicines</h3>
                <div className="ipd-medicine-inputs">
                  <div
                    className="ipd-med-wrapper"
                    tabIndex={0}
                    onBlur={() => setShowMedicineDropdown(false)}
                    ref={medicineDropdownRef}
                  >
                    <input
                      className="ipd-med-input"
                      placeholder="Search and select medicine..."
                      value={medicineSearchTerm}
                      onChange={(e) => {
                        setMedicineSearchTerm(e.target.value);
                        setShowMedicineDropdown(true);
                      }}
                      onFocus={() => setShowMedicineDropdown(true)}
                    />
                    {showMedicineDropdown && (
                      <div className="ipd-med-list">
                        {filteredMedicines.length > 0 ? (
                          filteredMedicines.map((med) => (
                            <div
                              key={med._id}
                              className="ipd-med-option"
                              onMouseDown={(e) => {
                                e.preventDefault();
                                setMedicineId(med._id);
                                setMedicineSearchTerm(med.name);
                                setShowMedicineDropdown(false);
                              }}
                            >
                              <span className="ipd-med-name">
                                {med.name}
                              </span>
                              <span className="ipd-med-price">
                                ₹{med.cost}
                              </span>
                            </div>
                          ))
                        ) : (
                          <div className="ipd-med-no-result">
                            No results found
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <input
                    className="ipd-input med-dropdown-dosage"
                    placeholder="Dosage"
                    type="number"
                    min="1"
                    value={medicineDosage}
                    onChange={(e) => setMedicineDosage(e.target.value)}
                  />

                  <button
                    className="ipd-button ipd-button-secondary med-dropdown-add-btn"
                    onClick={addMedicine}
                    disabled={!medicineId || !medicineDosage}
                  >
                    Add Medicine
                  </button>
                </div>
              </div>

              {medicines.length > 0 && (
                <div className="ipd-medicines-list-container">
                  <h4 className="ipd-list-title">Prescribed Medicines</h4>
                  <ul className="ipd-medicines-list">
                    {medicines.map((m, i) => (
                      <li key={i} className="ipd-medicine-item">
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                          }}
                        >
                          <span className="ipd-medicine-name">{m.name}</span>
                          <span className="ipd-medicine-details">
                            Total Cost: ₹{m.dosage * m.cost} ({m.cost}/medicine)
                          </span>
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            removeMedicine(i);
                          }}
                          className="ipd-remove-button"
                          title="Remove medicine"
                        >
                          <FaTrashAlt />
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Food Charges Section */}
              <div className="ipd-section" style={{ marginTop: "1rem" }}>
                <h3 className="ipd-section-title">Food Charges</h3>
                <p
                  className="ipd-section-subtitle"
                  style={{
                    fontSize: "0.9rem",
                    color: "#666",
                    marginBottom: "1rem",
                  }}
                >
                  Record food items provided to the patient
                </p>

                <div className="ipd-form-row">
                  <div className="ipd-input-group">
                    <label className="ipd-label">Food Item Name</label>
                    <input
                      className="ipd-input"
                      placeholder="e.g. Breakfast, Lunch, Dinner"
                      value={foodItemName}
                      onChange={(e) => setFoodItemName(e.target.value)}
                    />
                  </div>
                  <div className="ipd-input-group">
                    <label className="ipd-label">Quantity</label>
                    <input
                      type="number"
                      min="1"
                      className="ipd-input"
                      placeholder="e.g. 2"
                      value={foodQuantity}
                      onChange={(e) => setFoodQuantity(e.target.value)}
                    />
                  </div>
                </div>

                <div className="ipd-form-row">
                  <div className="ipd-input-group">
                    <label className="ipd-label">Price per Unit (₹)</label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="ipd-input"
                      placeholder="e.g. 50.00"
                      value={foodPrice}
                      onChange={(e) => setFoodPrice(e.target.value)}
                    />
                  </div>
                  <div className="ipd-input-group">
                    <label className="ipd-label">Date</label>
                    <CustomDatePicker
                      label="Select Date"
                      value={foodDate}
                      onChange={setFoodDate}
                      maxDate={dayjs()}
                    />
                  </div>
                  <div className="ipd-input-group">
                    <label className="ipd-label">Time</label>
                    <CustomTimePicker
                      label="Select Time"
                      value={foodTime}
                      onChange={setFoodTime}
                    />
                  </div>
                </div>

                <button
                  className="ipd-button ipd-button-secondary"
                  onClick={addFoodCharge}
                  style={{ marginTop: "0.5rem" }}
                >
                  Add Food Charge
                </button>
              </div>

              {foodCharges.length > 0 && (
                <div
                  className="ipd-medicines-list-container"
                  style={{ marginTop: "1rem" }}
                >
                  <h4 className="ipd-list-title">Food Charges Added</h4>
                  <ul className="ipd-medicines-list">
                    {foodCharges.map((food, index) => (
                      <li
                        key={index}
                        className="ipd-medicine-item"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <span
                            className="ipd-medicine-name"
                            style={{ display: "block", fontWeight: "600" }}
                          >
                            {food.itemName}
                          </span>
                          <span
                            className="ipd-medicine-details"
                            style={{ fontSize: "0.85rem", color: "#666" }}
                          >
                            Qty: {food.quantity} × ₹{food.price} = ₹
                            {food.totalCost} | {formatFoodChargeDate(food.date)}{" "}
                            at {formatFoodChargeTime(food.date, food.time)}
                          </span>
                        </div>
                        <button
                          className="ipd-button"
                          onClick={() => removeFoodCharge(index)}
                          style={{
                            backgroundColor: "#dc3545",
                            color: "white",
                            padding: "0.3rem 0.8rem",
                            fontSize: "0.85rem",
                            marginLeft: "1rem",
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                  </ul>
                  <div
                    className="ipd-total-cost"
                    style={{
                      marginTop: "1rem",
                      padding: "0.75rem",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "4px",
                    }}
                  >
                    <strong>
                      Total Food Charges: ₹
                      {foodCharges
                        .reduce((sum, food) => sum + food.totalCost, 0)
                        .toFixed(2)}
                    </strong>
                  </div>
                </div>
              )}
            </div>

            <div className="ipd-modal-footer">
              <button
                className="ipd-button"
                onClick={handleCloseObservationModal}
              >
                Cancel
              </button>
              <button
                className="ipd-button ipd-button-primary"
                onClick={handleAddObservation}
              >
                Save Observation
              </button>
            </div>
          </div>
        </div>
      )}

      {admissionId && (
        treatmentsData.length > 0 ? (
          <div className="ipd-table-wrapper">
            <table className="ipd-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {treatmentsData.map((t) => (
                  <tr key={t._id}>
                    <td>{formatDate(t.date)}</td>
                    <td>{t.time}</td>
                    <td>
                      <button
                        className="ipd-button ipd-button-view"
                        onClick={() => {
                          setSelectedTreatment(t);
                          setIsTreatmentModalOpen(true);
                        }}
                      >
                        View Details
                      </button>

                      <button
                        className="ipd-button ipd-button-edit"
                        onClick={() => handleEditObservation(t)}
                      >
                        Edit Observation
                      </button>
                      <button
                        className="ipd-button ipd-button-delete"
                        onClick={() => handleDeleteObservation(t._id)}
                      >
                        Delete Observation
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="ipd-empty">
            <h3 className="ipd-empty-title">No observations yet</h3>
            <p className="ipd-empty-desc">
              This admission has no daily observations. Use Add Observation to
              record vitals, medicines, and treatments.
            </p>
          </div>
        )
      )}

      {showEditModal && (
        <div className="ipd-modal-overlay">
          <div className="ipd-modal">
            <div className="ipd-modal-header">
              <h3>Edit Observation</h3>
              <button className="ipd-modal-close" onClick={handleCloseEditModal}>
                <FaTimes />
              </button>
            </div>

            <div className="ipd-modal-body">
              {/* Notes */}
              <div className="ipd-input-group">
                <label className="ipd-label">Notes</label>
                <textarea
                  className="ipd-textarea"
                  placeholder="Enter notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
                {errors.notes && (
                  <p className="ipd-error-text">{errors.notes}</p>
                )}
              </div>

              {/* Observations */}
              <div className="ipd-input-group">
                <label className="ipd-label">BP</label>
                <input
                  className="ipd-input"
                  placeholder="e.g. 120/80"
                  value={bp}
                  onChange={(e) => setBp(e.target.value)}
                />
                {errors.bp && <p className="ipd-error-text">{errors.bp}</p>}
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Pulse</label>
                <input
                  className="ipd-input"
                  placeholder="e.g. 72"
                  value={pulse}
                  onChange={(e) => setPulse(e.target.value)}
                />
                {errors.pulse && (
                  <p className="ipd-error-text">{errors.pulse}</p>
                )}
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Temperature (°F)</label>
                <input
                  className="ipd-input"
                  placeholder="e.g. 98.6"
                  value={temperature}
                  onChange={(e) => setTemperature(e.target.value)}
                />
                {errors.temperature && (
                  <p className="ipd-error-text">{errors.temperature}</p>
                )}
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Oxygen (%)</label>
                <input
                  className="ipd-input"
                  placeholder="e.g. 98"
                  value={oxygen}
                  onChange={(e) => setOxygen(e.target.value)}
                />
                {errors.oxygen && (
                  <p className="ipd-error-text">{errors.oxygen}</p>
                )}
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Weight (kg)</label>
                <input
                  className="ipd-input"
                  placeholder="e.g. 65"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                />
                {errors.weight && (
                  <p className="ipd-error-text">{errors.weight}</p>
                )}
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Complaints</label>
                <textarea
                  className="ipd-textarea"
                  placeholder="Enter complaints"
                  value={complaints}
                  onChange={(e) => setComplaints(e.target.value)}
                />
                {errors.complaints && (
                  <p className="ipd-error-text">{errors.complaints}</p>
                )}
              </div>

              {/* Treatments */}
              <div className="ipd-section">
                <h3 className="ipd-section-title">Treatments</h3>
                <div className="ipd-dropdown-wrapper">
                  <button
                    className="ipd-dropdown-toggle"
                    onClick={toggleDropdown}
                  >
                    Select Treatments{" "}
                    <span style={{ fontSize: "14px" }}>▾</span>
                  </button>

                  {isDropdownOpen && (
                    <div className="ipd-dropdown-menu">
                      {treatmentOptions.map((opt) => (
                        <div key={opt._id} className="ipd-checkbox-wrapper">
                          <label className="ipd-checkbox">
                            <input
                              type="checkbox"
                              checked={treatments.some(
                                (t) => t._id === opt._id
                              )}
                              onChange={() => handleTreatmentToggle(opt)}
                            />
                            <span className="ipd-checkbox-custom"></span>
                            <span className="ipd-checkbox-label">
                              {opt.name} (₹{opt.cost})
                            </span>
                          </label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {errors.treatments && (
                  <p className="ipd-error">{errors.treatments}</p>
                )}

                {treatments.length > 0 && (
                  <div
                    className="ipd-medicines-list-container"
                    style={{ marginTop: "0.5rem" }}
                  >
                    <h4 className="ipd-list-title">Selected Treatments</h4>
                    <ul className="ipd-medicines-list">
                      {treatments.map((treatment) => (
                        <li key={treatment._id} className="ipd-medicine-item">
                          <div
                            style={{
                              flex: 1,
                              display: "flex",
                              gap: "5px",
                              alignItems: "center",
                            }}
                          >
                            <span className="ipd-medicine-name">
                              {treatment.name}
                            </span>
                            {treatment.cost && (
                              <span className="ipd-medicine-details">
                                (₹{treatment.cost})
                              </span>
                            )}
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              removeTreatment(treatment._id);
                            }}
                            className="ipd-remove-button"
                            title="Remove treatment"
                          >
                            <FaTrashAlt />
                          </button>
                        </li>
                      ))}
                    </ul>
                    <div
                      className="ipd-total-cost"
                      style={{
                        marginTop: "1rem",
                        padding: "0.75rem",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                      }}
                    >
                      <strong>
                        Total Treatments Cost: ₹
                        {treatments.reduce(
                          (total, treatment) => total + (treatment.cost || 0),
                          0
                        )}
                      </strong>
                    </div>
                  </div>
                )}
              </div>

              {/* Medicines */}
              <div className="ipd-section">
                <h3 className="ipd-section-title">Medicines</h3>
                <div className="ipd-medicine-inputs">
                  <div
                    className="ipd-med-wrapper"
                    tabIndex={0}
                    onBlur={() => setShowMedicineDropdown(false)}
                    ref={medicineDropdownRef}
                  >
                    <input
                      className="ipd-med-input"
                      placeholder="Search and select medicine..."
                      value={medicineSearchTerm}
                      onChange={(e) => {
                        setMedicineSearchTerm(e.target.value);
                        setShowMedicineDropdown(true);
                      }}
                      onFocus={() => setShowMedicineDropdown(true)}
                    />
                    {showMedicineDropdown && (
                      <div className="ipd-med-list">
                        {filteredMedicines.length > 0 ? (
                          filteredMedicines.map((med) => (
                            <div
                              key={med._id}
                              className="ipd-med-option"
                              onMouseDown={(e) => {
                                e.preventDefault();
                                setMedicineId(med._id);
                                setMedicineSearchTerm(med.name);
                                setShowMedicineDropdown(false);
                              }}
                            >
                              <span className="ipd-med-name">
                                {med.name}
                              </span>
                              <span className="ipd-med-price">
                                ₹{med.cost}
                              </span>
                            </div>
                          ))
                        ) : (
                          <div className="ipd-med-no-result">
                            No results found
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <input
                    className="ipd-input med-dropdown-dosage"
                    placeholder="Dosage"
                    type="number"
                    min="1"
                    value={medicineDosage}
                    onChange={(e) => setMedicineDosage(e.target.value)}
                  />
                  <button
                    className="ipd-button ipd-button-secondary med-dropdown-add-btn"
                    onClick={addMedicine}
                    disabled={!medicineId || !medicineDosage}
                  >
                    Add Medicine
                  </button>
                </div>

                {medicines.length > 0 && (
                  <div className="ipd-medicines-list-container">
                    <h4 className="ipd-list-title">Prescribed Medicines</h4>
                    <ul className="ipd-medicines-list">
                      {medicines.map((medicine, index) => (
                        <li key={index} className="ipd-medicine-item">
                          <div
                            style={{
                              flex: 1,
                              display: "flex",
                              gap: "5px",
                              alignItems: "center",
                            }}
                          >
                            <span className="ipd-medicine-name">
                              {medicine.name}
                            </span>
                            <span className="ipd-medicine-details">
                              Total Cost: ₹{calculateMedicineCost(medicine)} (
                              {medicine.cost}/medicine)
                            </span>
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              removeMedicine(index);
                            }}
                            className="ipd-remove-button"
                            title="Remove medicine"
                          >
                            <FaTrashAlt />
                          </button>
                        </li>
                      ))}
                    </ul>
                    <div
                      className="ipd-total-cost"
                      style={{
                        marginTop: "1rem",
                        padding: "0.75rem",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                      }}
                    >
                      <strong>
                        Total Medicines Cost: ₹{calculateTotalMedicineCost()}
                      </strong>
                    </div>
                  </div>
                )}
              </div>

              {/* Food Charges Section */}
              <div className="ipd-section" style={{ marginTop: "1rem" }}>
                <h3 className="ipd-section-title">Food Charges</h3>
                <p
                  className="ipd-section-subtitle"
                  style={{
                    fontSize: "0.9rem",
                    color: "#666",
                    marginBottom: "1rem",
                  }}
                >
                  Record food items provided to the patient
                </p>

                <div className="ipd-form-row">
                  <div className="ipd-input-group">
                    <label className="ipd-label">Food Item Name</label>
                    <input
                      className="ipd-input"
                      placeholder="e.g. Breakfast, Lunch, Dinner"
                      value={foodItemName}
                      onChange={(e) => setFoodItemName(e.target.value)}
                    />
                  </div>
                  <div className="ipd-input-group">
                    <label className="ipd-label">Quantity</label>
                    <input
                      type="number"
                      min="1"
                      className="ipd-input"
                      placeholder="e.g. 2"
                      value={foodQuantity}
                      onChange={(e) => setFoodQuantity(e.target.value)}
                    />
                  </div>
                </div>

                <div className="ipd-form-row">
                  <div className="ipd-input-group">
                    <label className="ipd-label">Price per Unit (₹)</label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="ipd-input"
                      placeholder="e.g. 50.00"
                      value={foodPrice}
                      onChange={(e) => setFoodPrice(e.target.value)}
                    />
                  </div>
                  <div className="ipd-input-group">
                    <label className="ipd-label">Date</label>
                    <CustomDatePicker
                      label="Select Date"
                      value={foodDate}
                      onChange={setFoodDate}
                      maxDate={dayjs()}
                    />
                  </div>
                  <div className="ipd-input-group">
                    <label className="ipd-label">Time</label>
                    <CustomTimePicker
                      label="Select Time"
                      value={foodTime}
                      onChange={setFoodTime}
                    />
                  </div>
                </div>

                <button
                  className="ipd-button ipd-button-secondary"
                  onClick={addFoodCharge}
                  style={{ marginTop: "0.5rem" }}
                >
                  Add Food Charge
                </button>
              </div>

              {foodCharges.length > 0 && (
                <div
                  className="ipd-medicines-list-container"
                  style={{ marginTop: "1rem" }}
                >
                  <h4 className="ipd-list-title">Food Charges Added</h4>
                  <ul className="ipd-medicines-list">
                    {foodCharges.map((food, index) => (
                      <li
                        key={index}
                        className="ipd-medicine-item"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <span
                            className="ipd-medicine-name"
                            style={{ display: "block", fontWeight: "600" }}
                          >
                            {food.itemName}
                          </span>
                          <span
                            className="ipd-medicine-details"
                            style={{ fontSize: "0.85rem", color: "#666" }}
                          >
                            Qty: {food.quantity} × ₹{food.price} = ₹
                            {food.totalCost} | {formatFoodChargeDate(food.date)}{" "}
                            at {formatFoodChargeTime(food.date, food.time)}
                          </span>
                        </div>
                        <button
                          className="ipd-remove-button"
                          onClick={() => removeFoodCharge(index)}
                          title="Remove food charge"
                        >
                          <FaTrashAlt />
                        </button>
                      </li>
                    ))}
                  </ul>
                  <div
                    className="ipd-total-cost"
                    style={{
                      marginTop: "1rem",
                      padding: "0.75rem",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "4px",
                    }}
                  >
                    <strong>
                      Total Food Charges: ₹
                      {foodCharges
                        .reduce((sum, food) => sum + food.totalCost, 0)
                        .toFixed(2)}
                    </strong>
                  </div>
                </div>
              )}
            </div>

            <div className="ipd-modal-footer">
              <button
                className="ipd-button ipd-button-cancel"
                onClick={handleCloseEditModal}
              >
                Cancel
              </button>
              <button
                className="ipd-button ipd-button-primary"
                onClick={handleSaveEdit}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {isTreatmentModalOpen && selectedTreatment && (
        <div className="ipd-modal-overlay">
          <div className="ipd-modal">
            <div className="ipd-modal-header">
              <h3>Treatment Details</h3>
              <button
                className="ipd-modal-close"
                onClick={() => setIsTreatmentModalOpen(false)}
              >
                <FaTimes />
              </button>
            </div>

            <div className="ipd-modal-body">
              <p>
                <strong>Date:</strong> {formatDate(selectedTreatment.date)}
              </p>
              <p>
                <strong>Time:</strong> {selectedTreatment.time}
              </p>
              <p>
                <strong>Notes:</strong> {selectedTreatment.notes}
              </p>
              <p>
                <strong>Complaints:</strong> {selectedTreatment.complaints}
              </p>

              <h4>Observations:</h4>
              <ul>
                <li>
                  <strong>BP:</strong> {selectedTreatment.observations?.bp}
                </li>
                <li>
                  <strong>Pulse:</strong>{" "}
                  {selectedTreatment.observations?.pulse}
                </li>
                <li>
                  <strong>Temperature:</strong>{" "}
                  {selectedTreatment.observations?.temperature}
                </li>
                <li>
                  <strong>Oxygen:</strong>{" "}
                  {selectedTreatment.observations?.oxygen}
                </li>
                <li>
                  <strong>Weight:</strong>{" "}
                  {selectedTreatment.observations?.weight}
                </li>
              </ul>

              <h4>Treatments:</h4>
              <ul>
                {selectedTreatment.treatments.map((t) => (
                  <li key={t._id}>
                    {t.name} - ₹{t.cost}
                  </li>
                ))}
              </ul>

              <h4>Medicines:</h4>
              <ul>
                {selectedTreatment.medicines.map((m) => (
                  <li key={m._id}>
                    {m.name} - Dosage: {m.dosage}, Cost per unit: ₹{m.cost}
                  </li>
                ))}
              </ul>

              {selectedTreatment.foodCharges &&
                selectedTreatment.foodCharges.length > 0 && (
                  <>
                    <h4>Food Charges:</h4>
                    <ul>
                      {selectedTreatment.foodCharges.map((food, index) => (
                        <li key={index}>
                          <strong>{food.itemName}</strong> - Qty:{" "}
                          {food.quantity} × ₹{food.price} = ₹{food.totalCost} |
                          Date: {formatFoodChargeDate(food.date)} at{" "}
                          {formatFoodChargeTime(food.date, food.time)}
                        </li>
                      ))}
                    </ul>
                    <div
                      className="ipd-total-cost"
                      style={{
                        marginTop: "0.75rem",
                        padding: "0.75rem",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                      }}
                    >
                      <strong>
                        Total Food Charges: ₹
                        {selectedTreatment.foodCharges
                          .reduce((sum, food) => sum + (food.totalCost || 0), 0)
                          .toFixed(2)}
                      </strong>
                    </div>
                  </>
                )}
            </div>

            <div className="ipd-modal-footer">
              <button
                className="ipd-button ipd-button-cancel"
                onClick={() => setIsTreatmentModalOpen(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Consultation Modal */}
      {showConsultationModal && (
        <div className="ipd-modal-overlay">
          <div className="ipd-modal">
            <div className="ipd-modal-header">
              <h3>
                {modalMode === "add" ? "Add Consultation" : "View Consultation"}
              </h3>
              <button
                className="ipd-modal-close"
                onClick={() => {
                  setShowConsultationModal(false);
                  resetConsultationForm();
                }}
              >
                <FaTimes />
              </button>
            </div>

            <div className="ipd-modal-body">
              <div className="ipd-section">
                <h3 className="ipd-section-title">Vital Observations</h3>
                <div className="ipd-form-row">
                  <div className="ipd-input-group">
                    <label className="ipd-label">BP</label>
                    <input
                      type="text"
                      className="ipd-input"
                      placeholder="e.g. 120/80"
                      value={bp}
                      onChange={(e) => setBp(e.target.value)}
                      readOnly={modalMode === "view"}
                    />
                  </div>
                  <div className="ipd-input-group">
                    <label className="ipd-label">BSL</label>
                    <input
                      type="text"
                      className="ipd-input"
                      placeholder="Blood sugar level"
                      value={bsl}
                      onChange={(e) => setBsl(e.target.value)}
                      readOnly={modalMode === "view"}
                    />
                  </div>
                </div>
                <div className="ipd-form-row">
                  <div className="ipd-input-group">
                    <label className="ipd-label">Weight</label>
                    <input
                      type="text"
                      className="ipd-input"
                      placeholder="e.g. 70 kg"
                      value={weight}
                      onChange={(e) => setWeight(e.target.value)}
                      readOnly={modalMode === "view"}
                    />
                  </div>
                  <div className="ipd-input-group">
                    <label className="ipd-label">Temperature</label>
                    <input
                      type="text"
                      className="ipd-input"
                      placeholder="e.g. 98.6 F"
                      value={temperature}
                      onChange={(e) => setTemperature(e.target.value)}
                      readOnly={modalMode === "view"}
                    />
                  </div>
                </div>
                <div className="ipd-form-row">
                  <div className="ipd-input-group">
                    <label className="ipd-label">Pulse</label>
                    <input
                      type="text"
                      className="ipd-input"
                      placeholder="Pulse description"
                      value={pulse}
                      onChange={(e) => setPulse(e.target.value)}
                      readOnly={modalMode === "view"}
                    />
                  </div>
                  <div className="ipd-input-group">
                    <label className="ipd-label">Follow-up Date</label>
                    <CustomDatePicker
                      label="Select Follow-up Date"
                      value={followUpDate}
                      onChange={setFollowUpDate}
                      disabled={modalMode === "view"}
                      minDate={dayjs().startOf("day")}
                    />
                  </div>
                </div>
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Complaints</label>
                <textarea
                  className="ipd-textarea"
                  placeholder="Describe patient complaints"
                  value={complaints}
                  onChange={(e) => setComplaints(e.target.value)}
                  readOnly={modalMode === "view"}
                />
              </div>

              <div className="ipd-input-group">
                <label className="ipd-label">Diagnosis</label>
                <textarea
                  className="ipd-textarea"
                  placeholder="Describe the diagnosis provided"
                  value={diagnosis}
                  onChange={(e) => setDiagnosis(e.target.value)}
                  readOnly={modalMode === "view"}
                />
              </div>

              <div className="ipd-section">
                <h3 className="ipd-section-title">Treatments</h3>
                <div className="ipd-dropdown-wrapper">
                  <button
                    className="ipd-dropdown-toggle"
                    onClick={toggleDropdown}
                    disabled={modalMode === "view"}
                    style={{ height: "56px" }}
                  >
                    Select Treatments ▼
                  </button>

                  {isDropdownOpen && (
                    <div className="ipd-dropdown-menu">
                      {treatmentOptions.map((opt) => (
                        <div key={opt._id} className="ipd-checkbox-wrapper">
                          <label className="ipd-checkbox">
                            <input
                              type="checkbox"
                              checked={treatments.some(
                                (t) => t.name === opt.name
                              )}
                              onChange={() => handleTreatmentToggle(opt.name)}
                              disabled={modalMode === "view"}
                            />
                            <span className="ipd-checkbox-custom"></span>
                            <span className="ipd-checkbox-label">
                              {opt.name} (₹{opt.cost})
                            </span>
                          </label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Show selected treatments */}
                {treatments.length > 0 && (
                  <div
                    className="ipd-medicines-list-container"
                    style={{ marginTop: "0.5rem" }}
                  >
                    <h4 className="ipd-list-title">Selected Treatments</h4>
                    <ul className="ipd-medicines-list">
                      {treatments.map((treatment, index) => (
                        <li
                          key={treatment._id || index}
                          className="ipd-medicine-item"
                        >
                          <div
                            style={{
                              flex: 1,
                              display: "flex",
                              gap: "5px",
                              alignItems: "center",
                            }}
                          >
                            <span className="ipd-medicine-name">
                              {treatment.name}
                            </span>
                            {treatment.cost && (
                              <span className="ipd-medicine-details">
                                (₹{treatment.cost})
                              </span>
                            )}
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleTreatmentToggle(treatment);
                            }}
                            className="ipd-remove-button"
                            title="Remove treatment"
                          >
                            <FaTrashAlt />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {modalMode === "add" && (
                <div className="ipd-section">
                  <h3 className="ipd-section-title">Medicines</h3>
                  <div className="ipd-medicine-inputs">
                    <div
                      className="ipd-med-wrapper"
                      tabIndex={0}
                      onBlur={() => setShowMedicineDropdown(false)}
                      ref={medicineDropdownRef}
                    >
                      <input
                        className="ipd-med-input"
                        placeholder="Search and select medicine..."
                        value={medicineSearchTerm}
                        onChange={(e) => {
                          setMedicineSearchTerm(e.target.value);
                          setShowMedicineDropdown(true);
                        }}
                        onFocus={() => setShowMedicineDropdown(true)}
                      />
                      {showMedicineDropdown && (
                        <div className="ipd-med-list">
                          {filteredMedicines.length > 0 ? (
                            filteredMedicines.map((med) => (
                              <div
                                key={med._id}
                                className="ipd-med-option"
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  setMedicineId(med._id);
                                  setMedicineSearchTerm(med.name);
                                  setShowMedicineDropdown(false);
                                }}
                              >
                                <span className="ipd-med-name">
                                  {med.name}
                                </span>
                                <span className="ipd-med-price">
                                  ₹{med.cost}
                                </span>
                              </div>
                            ))
                          ) : (
                            <div className="ipd-med-no-result">
                              No results found
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <input
                      className="ipd-input med-dropdown-dosage"
                      placeholder="Dosage"
                      type="number"
                      min="1"
                      value={medicineDosage}
                      onChange={(e) => setMedicineDosage(e.target.value)}
                    />
                    <button
                      className="ipd-button ba-button-secondary med-dropdown-add-btn"
                      onClick={addMedicine}
                      disabled={!medicineId || !medicineDosage}
                    >
                      Add Medicine
                    </button>
                  </div>
                </div>
              )}

              {medicines.length > 0 && (
                <div className="ipd-medicines-list-container">
                  <h4 className="ipd-list-title">Prescribed Medicines</h4>
                  <ul className="ipd-medicines-list">
                    {medicines.map((m, i) => (
                      <li key={i} className="ipd-medicine-item">
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                          }}
                        >
                          <span className="ipd-medicine-name">{m.name}</span>
                          <span className="ipd-medicine-details">
                            Total Cost: ₹{m.dosage * m.cost} ({m.cost}/medicine)
                          </span>
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            removeMedicine(i);
                          }}
                          className="ipd-remove-button"
                          title="Remove medicine"
                        >
                          <FaTrashAlt />
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <div className="ipd-modal-footer">
              <button
                className="ipd-button ba-button-cancel"
                onClick={() => {
                  setShowConsultationModal(false);
                  resetConsultationForm();
                }}
              >
                Close
              </button>
              {modalMode === "add" && (
                <button
                  className="ipd-button ba-button-primary"
                  onClick={handleSaveConsultation}
                  disabled={consultationLoading}
                >
                  {consultationLoading ? "Saving..." : "Save Consultation"}
                </button>
              )}
              {modalMode === "edit" && (
                <button
                  className="ipd-button ba-button-primary"
                  onClick={handleUpdateConsultation}
                  disabled={consultationLoading}
                >
                  {consultationLoading ? "Updating..." : "Update Consultation"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal for Delete */}
      <ConfirmationModal
        open={showDeleteConfirmModal}
        onClose={() => {
          setShowDeleteConfirmModal(false);
          setTreatmentIdToDelete(null);
        }}
        onConfirm={confirmDeleteObservation}
        title="Delete Observation"
        message="Are you sure you want to delete this observation? This action cannot be undone."
        confirmText="Delete"
        cancelText="Cancel"
        confirmButtonAppearance="primary"
        isDelete={true}
      />
    </div>
  );
}

export default IpdAll;
